<template>
  <el-form :model="ruleForm"
           status-icon
           :rules="rules"
           ref="ruleForm"
           label-width="180px">
    <el-form-item label="Old Password"
                  prop="oldPassword">
      <el-input type="password"
                v-model="ruleForm.oldPassword"
                auto-complete="off"></el-input>
    </el-form-item>
    <el-form-item label="New Password"
                  prop="newPassword" style="margin-bottom: 40px;">
      <el-input type="password"
                v-model="ruleForm.newPassword"
                auto-complete="off"></el-input>
    </el-form-item>
    <el-form-item label="Confirm New Password"
                  prop="checkPassword">
      <el-input type="password"
                v-model="ruleForm.checkPassword"
                auto-complete="off"></el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary"
                 @click="submitForm('ruleForm')">Submit</el-button>
      <el-button @click="resetForm('ruleForm')">Reset</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import Auth from '../utils/auth';
export default {
  data() {
    var validateCheckNewPassword = (rule, value, callback) => {
      if (value !== this.ruleForm.newPassword) {
        callback(new Error("Doesn't match new password!"));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        oldPassword: '',
        newPassword: '',
        checkPassword: '',
      },
      rules: {
        oldPassword: [{ required: true, message: 'Required', trigger: 'blur' }],
        newPassword: [
          {
            required: true,
            message: 'Required',
            trigger: 'blur',
          },
          {
            trigger: 'blur',
            pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
            message:
              'At least 8 from the mentioned characters. Should contain at least one digit, one lower case, one upper case.',
          },
        ],
        checkPassword: [
          {
            required: true,
            message: 'Required',
            trigger: 'blur',
          },
          {
            validator: validateCheckNewPassword,
            trigger: 'blur',
          },
        ],
      },
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.axios({
            method: 'put',
            url: '/user/password',
            data: {
              oldPassword: this.ruleForm.oldPassword,
              newPassword: this.ruleForm.newPassword,
            },
          })
            .then(res => {
              if (res.data.success) {
                this.$message({
                  message: 'Change Success! Please use new password to login.',
                  type: 'success',
                });
              }
              Auth.logout(() => {
                this.$router.push('/login');
              });
            })
            .catch(err => {
              console.log();
              this.$message({
                message: err.response.data.message,
                type: 'error',
              });
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ChangePassword.vue